import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import StepperShell from '@/views/sale/sale-stepper.shell.vue';
import store from '@/store';
import { WidgetState } from '@/store/widget/types';
import { date } from 'quasar';
import formatDate = date.formatDate;
import { setLanguage } from '@/i18n';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/:widgetId',
    name: 'Home',
    component: StepperShell,
  },
  {
    path: '/:widgetId/customer',
    name: 'CustomerPanel',
    component: () => import('@/views/customer-panel/customer-panel.shell.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const widgetState = (store.state as any).widget as WidgetState;

  if (!widgetState.isLoaded) {
    await setLanguage((to.query as any).lang || navigator.language);

    await store.dispatch('widget/fetchSettings', to.params.widgetId);

    if (widgetState.settings.market?.currency) {
      await store.commit('preferences/setCurrency', widgetState.settings.market?.currency);
    }

    await store.dispatch('cart/fetchCart');

    if (to.query) {
      const { checkInDate, checkOutDate, adults, children } = to.query as any;

      const payload: any = {};

      if (checkInDate) payload.checkInDate = new Date(checkInDate);
      if (checkOutDate) payload.checkOutDate = new Date(checkOutDate);
      if (typeof adults !== 'undefined') Number(adults);
      if (children) {
        payload.children = Array.isArray(children) ? children.map((child: any) => Number(child)) : [Number(children)];
      }
    }

    next();
  } else {
    await setLanguage(navigator.language);
    next();
  }

  // if (to.path !== "/login" && !store) {
  //   next("/login");
  // } else {
  //   next();
  // }
});

export default router;
